import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav
            className={classNames(
                'navbar navbar-expand-lg navbar-dark ftco_navbar ftco-navbar-light site-navbar-target',
                {
                    scrolled: isScrolled,
                    awake: isScrolled,
                    'sleep': !isScrolled && window.scrollY < 150
                }
            )}
            id="ftco-navbar"
        >
            <div className="container">
                <Link className="navbar-brand" to="/">Mohammad Sahil</Link>
                <button
                    className={classNames('navbar-toggler js-fh5co-nav-toggle fh5co-nav-toggle', { active: isMenuOpen })}
                    type="button"
                    onClick={toggleMenu}
                    aria-controls="ftco-nav"
                    aria-expanded={isMenuOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="oi oi-menu"></span> Menu
                </button>

                <div className={classNames('collapse navbar-collapse', { show: isMenuOpen })} id="ftco-nav">
                    <ul className="navbar-nav nav ml-auto">
                        <li className="nav-item"><a href="/#home-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>Home</span></a></li>
                        <li className="nav-item"><a href="/#about-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>About</span></a></li>
                        <li className="nav-item"><a href="/#resume-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>Resume</span></a></li>
                        <li className="nav-item"><a href="/#services-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>Services</span></a></li>
                        <li className="nav-item"><a href="/#skills-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>Skills</span></a></li>
                        <li className="nav-item"><a href="/#projects-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>Projects</span></a></li>
                        {/* <li className="nav-item"><a href="/#blog-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>My Blog</span></a></li> */}
                        <li className="nav-item"><a href="/#contact-section" className="nav-link" onClick={() => setIsMenuOpen(false)}><span>Contact</span></a></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
